(function () {
  "use strict";

  const root = document.querySelector("[data-be-quiz-results]");
  if (!root) return;

  const cfgUrl = root.getAttribute("data-config-url");
  const storageKey = root.getAttribute("data-storage-key") || "be_quiz_v1";

  function el(tag, attrs = {}, children = []) {
    const n = document.createElement(tag);
    Object.entries(attrs).forEach(([k, v]) => {
      if (k === "class") n.className = v;
      else if (k === "html") n.innerHTML = v;
      else n.setAttribute(k, v);
    });
    children.forEach((c) => n.appendChild(typeof c === "string" ? document.createTextNode(c) : c));
    return n;
  }

  function loadState() {
    try {
      return JSON.parse(localStorage.getItem(storageKey) || "null");
    } catch (e) {
      return null;
    }
  }

  function stripHtml(html) {
    const d = document.createElement("div");
    d.innerHTML = String(html || "");
    return (d.textContent || d.innerText || "").trim();
  }

  function money(value) {
    const raw = value ?? 0;

    // "26.99" => dollars
    if (typeof raw === "string") {
      const dollars = parseFloat(raw.replace(/[^0-9.]/g, ""));
      const safe = Number.isFinite(dollars) ? dollars : 0;
      return safe.toLocaleString(undefined, { style: "currency", currency: "USD" });
    }

    // cents number
    const num = Number(raw);
    const safeNum = Number.isFinite(num) ? num : 0;

    // heuristic: treat big numbers as cents
    const dollars = safeNum > 500 ? safeNum / 100 : safeNum;
    return dollars.toLocaleString(undefined, { style: "currency", currency: "USD" });
  }

  function fetchProductByHandle(handle) {
    if (!handle) return Promise.reject(new Error("Missing hero_handle in config."));
    return fetch("/products/" + handle + ".js", { credentials: "same-origin" }).then((r) => {
      if (!r.ok) throw new Error("Product fetch failed for handle: " + handle + " (HTTP " + r.status + ")");
      return r.json();
    });
  }

  function fetchCollectionProducts(handle) {
    if (!handle) return Promise.reject(new Error("Missing collection_handle in config."));
    const url = "/collections/" + handle + "/products.json?limit=250";
    return fetch(url, { credentials: "same-origin" }).then((r) => {
      if (!r.ok) {
        throw new Error(
          "Collection fetch failed for handle: " + handle + " (HTTP " + r.status + "). " +
          "If this is 404, the collection handle is wrong OR the collection is not available to the Online Store sales channel."
        );
      }
      return r.json();
    });
  }

  function firstVariantId(p) {
    if (!p || !p.variants || !p.variants.length) return null;
    return p.variants[0].id;
  }

  function imageUrl(p) {
    // product.js: featured_image is string URL; images is array of strings
    if (p && typeof p.featured_image === "string" && p.featured_image) return p.featured_image;

    // products.json: images can be array of objects with src
    if (p && Array.isArray(p.images) && p.images.length) {
      const first = p.images[0];
      if (typeof first === "string") return first;
      if (first && typeof first.src === "string") return first.src;
    }

    // products.json sometimes uses "image"
    if (p && p.image && typeof p.image.src === "string") return p.image.src;

    return "";
  }

  function displayPrice(p) {
    // product.js has p.price in cents
    if (p && p.price != null) return money(p.price);

    // products.json uses variants[0].price as string dollars
    if (p && p.variants && p.variants[0] && p.variants[0].price != null) return money(p.variants[0].price);

    return money(0);
  }

  function displayDescription(p) {
    // product.js: description
    if (p && p.description) return stripHtml(p.description);
    // products.json: body_html
    if (p && p.body_html) return stripHtml(p.body_html);
    return "";
  }

  function addToCart(variantId) {
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    }).then((r) => {
      if (!r.ok) throw new Error("Add to cart failed (HTTP " + r.status + ")");
      return r.json();
    });
  }

  function renderCard(p, opts) {
    if (!p) return el("div", { class: "be-qr-card" }, ["Product failed to load."]);

    const variantId = firstVariantId(p);
    const href = (p && p.url) || (p && p.handle ? "/products/" + p.handle : "#");

    const card = el("div", { class: "be-qr-card" });

    const imgSrc = imageUrl(p);
    const img = el("img", {
      class: "be-qr-img",
      src: imgSrc,
      alt: p.title || "",
      loading: "lazy",
    });

    // If image URL is empty or bad, hide it gracefully (no broken icon)
    img.addEventListener("error", () => {
      img.style.display = "none";
    });

    const title = el("div", { class: "be-qr-title" }, [p.title || ""]);
    const price = el("div", { class: "be-qr-price" }, [displayPrice(p)]);

    const fullDesc = displayDescription(p);
    const max = opts && opts.descMax ? Number(opts.descMax) : 170;
    const clipped = fullDesc.slice(0, max) + (fullDesc.length > max ? "…" : "");
    const desc = el("div", { class: "be-qr-desc" }, [clipped]);

    const btnRow = el("div", { class: "be-qr-btnrow" });

    const learn = el("a", { class: "be-qr-learn", href: href }, ["Learn more"]);

    const btn = el("button", { class: "be-qr-add", type: "button" }, ["Add to cart"]);
    btn.disabled = !variantId;

    btn.addEventListener("click", () => {
      if (!variantId) return;
      btn.disabled = true;
      btn.textContent = "Adding…";
      addToCart(variantId)
        .then(() => {
          btn.textContent = "Added";
          setTimeout(() => {
            btn.textContent = "Add to cart";
            btn.disabled = false;
          }, 900);
        })
        .catch(() => {
          btn.textContent = "Try again";
          btn.disabled = false;
        });
    });

    btnRow.appendChild(btn);
    btnRow.appendChild(learn);

    card.appendChild(img);
    card.appendChild(title);
    card.appendChild(price);
    card.appendChild(desc);
    card.appendChild(btnRow);

    return card;
  }

  function render(cfg, state) {
    const holder = el("div", { class: "be-quiz-results" });

    const bestPillarId = state && state.best && state.best.pillar ? state.best.pillar : null;
    if (!bestPillarId) {
      holder.appendChild(el("div", { class: "be-qr-empty" }, ["No quiz answers found. Please take the quiz first."]));
      root.innerHTML = "";
      root.appendChild(holder);
      return;
    }

    const pillar = (cfg.pillars || []).find((p) => p.id === bestPillarId);
    if (!pillar) {
      holder.appendChild(el("div", { class: "be-qr-empty" }, ["Quiz results found, but the pillar is missing from config."]));
      root.innerHTML = "";
      root.appendChild(holder);
      return;
    }

    const heading = el("h2", { class: "be-qr-h2" }, ["Here is your top recommendation:"]);
    holder.appendChild(heading);

    const codeLine =
      cfg.emailGate && cfg.emailGate.discountCode
        ? el("div", { class: "be-qr-code" }, ["Use code ", el("strong", {}, [cfg.emailGate.discountCode]), " at checkout"])
        : null;
    if (codeLine) holder.appendChild(codeLine);

    const heroWrap = el("div", { class: "be-qr-hero" });
    holder.appendChild(heroWrap);

    const alsoHeading = el("h3", { class: "be-qr-h3" }, ["Also recommended for you:"]);
    const alsoGrid = el("div", { class: "be-qr-grid" });

    const alsoCount = (cfg.results && Number(cfg.results.also_count)) || 3;
    const preferTag = (cfg.results && cfg.results.prefer_tag) || "Best Sellers";

    // Render immediately (so we can show partial success)
    root.innerHTML = "";
    root.appendChild(holder);

    // 1) Load hero first. If hero fails, show error, but keep page alive.
    fetchProductByHandle(pillar.hero_handle)
      .then((heroProduct) => {
        heroWrap.appendChild(renderCard(heroProduct, { descMax: 220 }));
      })
      .catch((err) => {
        console.error(err);
        heroWrap.appendChild(
          el("div", { class: "be-qr-empty" }, ["Hero product failed to load: ", (err && err.message) ? err.message : "Unknown error"])
        );
      })
      .finally(() => {
        // 2) Load collection for "Also recommended"
        fetchCollectionProducts(pillar.collection_handle)
          .then((collJson) => {
            const products = collJson && Array.isArray(collJson.products) ? collJson.products : [];

            // Filter out hero by handle
            const heroHandle = pillar.hero_handle;
            const withoutHero = products.filter((p) => p && p.handle !== heroHandle);

            // Prefer tag
            const tagged = withoutHero.filter((p) => {
              const tags = p && Array.isArray(p.tags) ? p.tags : [];
              return tags.includes(preferTag);
            });

            const pool = tagged.length >= alsoCount ? tagged : withoutHero;
            const pick = pool.slice(0, alsoCount);

            if (!pick.length) return; // no also products

            holder.appendChild(alsoHeading);

            pick.forEach((p) => {
              // ensure these fields exist for our renderer
              p.url = "/products/" + p.handle;
              alsoGrid.appendChild(renderCard(p, { descMax: 120 }));
            });

            holder.appendChild(alsoGrid);
          })
          .catch((err) => {
            console.error(err);
            holder.appendChild(
              el("div", { class: "be-qr-empty" }, ["Also recommended failed: ", (err && err.message) ? err.message : "Unknown error"])
            );
          })
          .finally(() => {
            // Retake always
            const retake = el("a", { class: "be-qr-retake", href: "/pages/product-recommendation-quiz?retake=1" }, ["Retake quiz"]);

retake.addEventListener("click", function () {
  try {
    // clear whatever key the quiz uses
    // (this results page already knows it via data-storage-key)
    localStorage.removeItem(storageKey);
  } catch (e) {}
});

holder.appendChild(retake);
          });
      });
  }

  fetch(cfgUrl, { credentials: "same-origin" })
    .then((r) => {
      if (!r.ok) throw new Error("Config fetch failed: HTTP " + r.status);
      return r.json();
    })
    .then((cfg) => {
      const state = loadState();
      render(cfg, state);
    })
    .catch((err) => {
      console.error(err);
      root.innerHTML =
        '<div class="be-qr-empty">Results failed to load. Check that <strong>be-quiz-config.json</strong> exists and that the results section is on this page.</div>';
    });
})();